/* shop-on-discount section */
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".brands-discount-tab");
    const cards = document.querySelectorAll(".brands-discount-card");

    function normalize(str) {
        return str.trim().toLowerCase();
    }

    function filterCards(tab) {
        const normalized = normalize(tab);
        cards.forEach(card => {
            card.style.display = (normalize(card.getAttribute("data-tab")) === normalized) ? "block" : "none";
        });
    }

    // Initial state: show first tab's cards
    if (tabs.length > 0) {
        const firstTab = tabs[0];
        firstTab.classList.add("active");
        filterCards(firstTab.getAttribute("data-tab"));
    }

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            const selected = tab.getAttribute("data-tab");
            tabs.forEach(t => t.classList.remove("active"));
            tab.classList.add("active");
            filterCards(selected);
        });
    });
});

/*shop-by-category section */
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".category-tab");
    const cards = document.querySelectorAll(".shop-by-categories-card");

    function filterCards(category) {
        cards.forEach(card => {
            if (card.getAttribute("data-category") === category) {
                card.style.display = "block";
            } else {
                card.style.display = "none";
            }
        });
    }

    function setActiveTab(tab) {
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
    }

    // Preselect first two tabs for alternation, fallback if less than 2 tabs
    const firstTab = tabs[0];
    const secondTab = tabs.length > 1 ? tabs[1] : null;

    // Start with first tab selected
    let currentIndex = 0;
    setActiveTab(firstTab);
    filterCards(firstTab.getAttribute("data-category"));

    // Alternate between first and second tab every minute
    if (secondTab) {
        setInterval(() => {
            currentIndex = 1 - currentIndex; 
            const tabToSelect = currentIndex === 0 ? firstTab : secondTab;
            setActiveTab(tabToSelect);
            filterCards(tabToSelect.getAttribute("data-category"));
        }, 30000); 
    }

    // Also allow manual click to select a tab and override the auto cycle temporarily
    tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            setActiveTab(tab);
            filterCards(tab.getAttribute("data-category"));
            // Update currentIndex so that auto-switch continues correctly
            if (tab === firstTab) {
                currentIndex = 0;
            } else if (tab === secondTab) {
                currentIndex = 1;
            }
        });
    });
});

/* hotspot-with-product section */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hotspot').forEach(function (hotspot) {
      const popup = hotspot.querySelector('.hotspot-product-popup');
      const container = hotspot.closest('.hotspot-image-container');

      function adjustPopupPosition() {
        const containerWidth = container.offsetWidth;
        const hotspotLeft = hotspot.offsetLeft;
        const popupWidth = popup.offsetWidth;

        if (hotspotLeft + popupWidth + 20 > containerWidth) {
          popup.style.left = 'auto';
          popup.style.right = '100%';
          popup.style.transform = 'translate(-10px, -20px)';
        } else {
          popup.style.left = '55%';
          popup.style.right = 'auto';
          popup.style.transform = 'translate(-50px, -20px)';
        }
      }

      adjustPopupPosition();
      window.addEventListener('resize', adjustPopupPosition);
    });
  });